<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'TaskInfoItem',
})

withDefaults(defineProps<TaskInfoItemProps>(), {
  required: false,
})

interface TaskInfoItemProps {
  title: string
  required?: boolean
}

</script>

<template>
  <div class="task-info-item">
    <div class="task-info-item__title">
      <slot name="title">
        <AppText
          name="body1"
          color="slate-500"
        >
          {{ title }}<span
            v-if="required"
            class="task-info-item__required"
          >*</span>
        </AppText>
      </slot>
    </div>

    <slot />
  </div>
</template>

<style scoped lang="scss" src="./TaskInfoItem.scss" />
